import React from "react";
import { Link } from "react-router-dom";
import { PRODUCTS2 } from "../../products";
import { Product } from "./product2";
import "./shop2.css";

export const Shop2 = () => {
  return (
    <div className="shop">
      <div className="links2">
        <Link to="/"> Food </Link>
        <Link to="/Drinks"> Drink </Link>
        <Link to="/Snacks"> Snack </Link>
      </div>
      <div className="products">
        {PRODUCTS2.map
          ((product) => 
            (<Product data={product} />
            )
          )
        }
      </div>
    </div>
  );
};